<template>
    <div class="object__right object__right--flex-top entity-header__btns">
        <div v-if="!account.IsBlocked" class="object__buttons">
            <div class="object__ctrl-group link">
                <div class="object__ctrl-btn button button--th-main" v-on:click="pay(idxAcc)">Оплатить</div>
                <div class="object__ctrl-down object__ctrl-down--secondary">
                    до 10 числа
                </div>
            </div>
            <a :href="'#auto_payment_*'+account.PersonAccountId" class="object__ctrl-group js-collapse-toggle" data-toggle="collapse" data-scroll-to>
                <!--<div class="object__ctrl-btn button button--th-ctrl">Автоплатёж: <br /></div>-->
                <div class="object__ctrl-btn button button--th-main is-disable">Автоплатёж<br /></div>
                <div class="object__ctrl-down">
                    в разработке
                </div>
            </a>
            <a href="/FL/equipments/equipments" class="object__ctrl-group">
                <div class="object__ctrl-btn button button--th-main">Передать <br>показания</div>
                <div class="object__ctrl-down object__ctrl-down--secondary">
                    {{account.ReadingPeriod.BeginDay}} - {{account.ReadingPeriod.EndDay}} число
                </div>
            </a>
            <a :href="'#epd_*'+account.PersonAccountId" data-toggle="collapse" class="object__ctrl-group js-collapse-toggle js-change-button-old"
               data-scroll-to style="display: none;">
                <div class="object__ctrl-btn button button--th-main is-disable">Рассылка ЕПД<br /></div>
                <div class="object__ctrl-down">
                    в разработке
                </div>
            </a>
            <div v-if="account.EpdStartDate==null" :href="'#auto_payment_*'+account.PersonAccountId" class="object__ctrl-group js-collapse-toggle" data-toggle="collapse" data-scroll-to>
                <div class="object__ctrl-btn button button--th-main is-disable">Платежный<br /> документ</div>
                <div class="object__ctrl-down">
                    Получить
                </div>
            </div>
            <a v-else :href="'#epd_'+account.PersonAccountId" data-toggle="collapse" class="object__ctrl-group js-collapse-toggle js-change-button-new"
               data-scroll-to>
                <div class="object__ctrl-btn button button--th-main">Платежный<br /> документ</div>
                <div class="object__ctrl-down object__ctrl-down--secondary">
                    Получить
                </div>
            </a>
            <a @click="pay(-1)" :href="'#oI_'+account.BspId+'_'+account.PersonAccountId" class="object__ctrl-group collapsed js-collapse-toggle" data-toggle="collapse"
               data-scroll-to>
                <div class="object__ctrl-btn button button--th-main">Состояние <br /> лицевого счета</div>
                <div class="object__ctrl-down object__ctrl-down--secondary">
                    {{account.CalcPeriod.replace(' г.','')}}
                </div>
            </a>
        </div>
        <a @click="pay(-1)" :href="'#oI_'+account.BspId+'_'+account.PersonAccountId" :id="'btn_'+account.BspId+'_'+account.PersonAccountId"
           class="object__ctrl-arrow collapse-link collapse-link--second link link--underline collapsed js-collapse-toggle"
           data-toggle="collapse" data-scroll-to>
            <span class="link__icon fab-icon">
                <i class="icon icon--angle-down"></i>
            </span>
        </a>
    </div>
</template>

<script type="text/javascript">
    export default {
        name: 'account-buttons',
        props: {
            account: Object,
            idxAcc: Number
        },
        data: function () {
            return {
                isSber: false
            }
        },
        methods: {
            pay: function (idx) {
                this.$emit('updateIdxShow', idx);
                if (idx >= 0) {
                    var pict = document.getElementById('btn_' + this.account.BspId + '_' + this.account.PersonAccountId);
                    if (pict.className.indexOf('collapsed') < 0)
                        pict.classList.add('collapsed');
                }
                return;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Scripts/app/fl/components/account-buttons.vue